/* eslint-disable react/jsx-props-no-spreading */
import React, { SVGProps } from 'react';

const ThreeDots = ({
  color = 'var(--headerIconColor)',
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    width={3}
    height={14}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    data-palette="ThreeDots">
    <path
      d="M.375 0h2.25v2H.375V0Zm0 6h2.25v2H.375V6Zm0 6h2.25v2H.375v-2Z"
      fill={color}
    />
  </svg>
);

export default ThreeDots;
